<template>
  <div>
    <div class="d-flex justify-content-center" v-if="this.loading"><b-spinner :label="$t('common_phrases.loading')"></b-spinner></div>
    
    <b-img-lazy v-if="!this.loading && this.validImage" fluid :src="this.imgData" :width="this.width"/>
    <b-icon icon="image" style="color: #E8E8E8; margin-top: 30px;" font-scale="10.5" v-if="!this.validImage"></b-icon>

    <div v-if="showResolution" class='img-res'>{{ this.resolution }} </div>
  </div>
</template>

<script>
import announcements from '@/store/announcements/announcements'

export default {
    props: {
      imageid: Number,
      width : Number,
      showResolution: { type: Boolean, default: true },
    },
    data: function() {
      return {
        imgData: null,
        loading: true,
        validImage: true,
        resolution: ""
      }
    },
    beforeCreate() {
      if (!this.$store.state.announcements ) {
          this.$store.registerModule("announcements" , announcements);
      }
    },
    mounted() {
      this.getImageData(this.imageid);
    },
    watch: {
      imageid: function( uusi) {
        this.getImageData(uusi);
      }
    },
    methods: {
      getImageData: function(kuva) {
        this.loading = true;
        this.$store.dispatch('announcements/getAnnouncementImage' , kuva )
          .then( (data) => {
            this.imgData = data; 
            this.loading = false;

            this.resolution = "";
            this.validImage = data && data != 'null'; 
            if(this.validImage) {
              var self = this;
              var i = new Image(); 
              i.onload = function(){
                self.resolution =  i.width + " x " + i.height;
              };
              i.src = this.imgData;
            } 

           },
             () => {/* TODO: ei virheentarkistusta */}
           );
      }
    }

}
</script>


<style scoped lang="scss">

.img-res {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1px;
  margin-top: 4px;
}
.img-fluid {
    /* max-height: 160px; */
}

</style>